import React, { useState } from 'react';
import GenderSelection from './GenderSelection';
import './Onboarding.css';
import Footer from './Footer';

const Onboarding = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [userData, setUserData] = useState({
    gender: null,
    ageRange: null,
    cookingLevel: null,
    cuisinePreferences: [],
    // Additional user data can be collected in later steps
  });
  
  // Total number of steps in the stepper
  const totalStepperSteps = 3;
  
  const handleGenderSelection = (gender) => {
    setUserData({ ...userData, gender });
    setCurrentStep(prevStep => prevStep + 1);
  };

  const handleAgeSelection = (ageRange) => {
    setUserData({ ...userData, ageRange });
    setCurrentStep(prevStep => prevStep + 1);
  };

  const handleCookingLevelSelection = (cookingLevel) => {
    setUserData({ ...userData, cookingLevel });
    setCurrentStep(prevStep => prevStep + 1);
  };

  const handleCuisineSelection = (cuisine) => {
    const currentPreferences = [...userData.cuisinePreferences];
    
    // If already selected, remove it
    if (currentPreferences.includes(cuisine)) {
      const updatedPreferences = currentPreferences.filter(pref => pref !== cuisine);
      setUserData({ ...userData, cuisinePreferences: updatedPreferences });
    } 
    // Otherwise add it
    else {
      setUserData({ ...userData, cuisinePreferences: [...currentPreferences, cuisine] });
    }
  };

  const handleCuisineComplete = () => {
    onComplete && onComplete({ 
      ...userData,
      gender: userData.gender, 
      ageRange: userData.ageRange,
      cookingLevel: userData.cookingLevel,
      cuisinePreferences: userData.cuisinePreferences
    });
  };
  
  const handleNext = () => {
    if (currentStep < totalStepperSteps) {
      setCurrentStep(prevStep => prevStep + 1);
    }
  };
  
  // Stepper indicator component
  const renderStepIndicator = () => {
    return (
      <div className="step-indicator">
        {Array.from({ length: totalStepperSteps }).map((_, index) => (
          <div 
            key={index} 
            className={`step-dot ${index === currentStep ? 'active' : ''}`} 
          />
        ))}
      </div>
    );
  };
  
  // First intro step
  const renderFirstStep = () => {
    return (
      <div className="welcome-container">
        <div className="welcome-image-container">
          <img 
            src="https://img.freepik.com/free-photo/happy-young-woman-chef-uniform-holding-frying-pan_171337-5343.jpg"
            className="chef-image"
            alt="Chef" 
          />
        </div>
        <div className="welcome-content">
          <h1>YemekTarifleri.Ai'ya Hoşgeldiniz</h1>
          <p className="welcome-text">
            Yemek Tarifleri AI ile tanışmaya hazır mısın? Lezzetli tarifler, kolay adımlar ve sana özel önerilerle buradayız.
          </p>
          {renderStepIndicator()}
          <button className="continue-btn" onClick={handleNext}>
            Devam <span className="arrow">→</span>
          </button>
        </div>
      </div>
    );
  };
  
  // Second intro step
  const renderSecondStep = () => {
    return (
      <div className="welcome-container">
        <div className="welcome-image-container">
          <img 
            src="/images/real-fridge.jpg"
            className="chef-image"
            alt="Dolabında Ne Var" 
          />
        </div>
        <div className="welcome-content">
          <h1>Dolabında Ne Var?<br />Malzemelerini Keşfet!</h1>
          <p className="welcome-text">
            İstersen elindeki malzemeleri tek tek gir, ya da sadece dolabının fotoğrafını çek. Yapay zeka teknolojimiz, elindeki malzemeleri analiz edip sana özel tarifler önerecek. Hemen başlayalım mı?
          </p>
          {renderStepIndicator()}
          <button className="continue-btn" onClick={handleNext}>
            Devam <span className="arrow">→</span>
          </button>
        </div>
      </div>
    );
  };
  
  // Third intro step
  const renderThirdStep = () => {
    return (
      <div className="welcome-container">
        <div className="welcome-image-container">
          <div className="spices-image-container">
            <img 
              src="https://images.unsplash.com/photo-1588166524941-3bf61a9c41db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80"
              className="chef-image"
              alt="Lezzetli Tarifler" 
            />
          </div>
        </div>
        <div className="welcome-content">
          <h1>Lezzetli Tarifler Seni Bekliyor</h1>
          <p className="welcome-text">
            Artık sana özel yapay zeka destekli tarif önerilerine ulaşabilirsin. Malzemesiz de keşfetmek istersen, hazır tarifler seni bekliyor!
          </p>
          {renderStepIndicator()}
          <button className="continue-btn" onClick={handleNext}>
            Devam <span className="arrow">→</span>
          </button>
        </div>
      </div>
    );
  };

  // Age Range Selection
  const renderAgeRangeStep = () => {
    return (
      <div className="welcome-container">
        <div className="welcome-content">
          <h1>Bize kendinizden bahseder misiniz?</h1>
          <p className="welcome-text">
            Size daha iyi bir deneyim sunmak için yaşınızı bilmemiz gerekiyor.
          </p>
          
          <div className="age-range-container">
            <button 
              className={`age-range-btn ${userData.ageRange === "18-24" ? "active" : ""}`} 
              onClick={() => handleAgeSelection("18-24")}
            >
              18 - 24
            </button>
            
            <button 
              className={`age-range-btn ${userData.ageRange === "24-32" ? "active" : ""}`} 
              onClick={() => handleAgeSelection("24-32")}
            >
              24 - 32
            </button>
            
            <button 
              className={`age-range-btn ${userData.ageRange === "32-40" ? "active" : ""}`} 
              onClick={() => handleAgeSelection("32-40")}
            >
              32 - 40
            </button>
            
            <button 
              className={`age-range-btn ${userData.ageRange === "40-65" ? "active" : ""}`} 
              onClick={() => handleAgeSelection("40-65")}
            >
              40 - 65
            </button>
            
            <button 
              className={`age-range-btn ${userData.ageRange === "65+" ? "active" : ""}`} 
              onClick={() => handleAgeSelection("65+")}
            >
              65+
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Cooking Level Selection
  const renderCookingLevelStep = () => {
    return (
      <div className="welcome-container">
        <div className="welcome-content">
          <h1>Yemek yapma seviyeniz nedir?</h1>
          <p className="welcome-text">
            Size daha iyi bir deneyim sunmak için aşçılık seviyenizi bilmemiz gerekiyor.
          </p>
          
          <div className="cooking-level-container">
            <button 
              className={`cooking-level-btn ${userData.cookingLevel === "beginner" ? "active" : ""}`} 
              onClick={() => handleCookingLevelSelection("beginner")}
            >
              Başlangıç
              <div className="level-description">Yemek yapmaya yeni başladım</div>
            </button>
            
            <button 
              className={`cooking-level-btn ${userData.cookingLevel === "intermediate" ? "active" : ""}`} 
              onClick={() => handleCookingLevelSelection("intermediate")}
            >
              Orta Seviye
              <div className="level-description">Ara ara yemek yapıyorum</div>
            </button>
            
            <button 
              className={`cooking-level-btn ${userData.cookingLevel === "expert" ? "active" : ""}`} 
              onClick={() => handleCookingLevelSelection("expert")}
            >
              Uzman
              <div className="level-description">Her tarifi yapabilirim</div>
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Cuisine Preferences Selection
  const renderCuisinePreferencesStep = () => {
    return (
      <div className="welcome-container">
        <div className="welcome-content">
          <h1>Hangi mutfakları tercih edersiniz?</h1>
          <p className="welcome-text">
            Size daha iyi bir deneyim sunmak için mutfak tercihlerinizi bilmemiz gerekiyor.
          </p>
          
          <div className="cuisine-container">
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("italian") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("italian")}
            >
              🍕 İtalya
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("american") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("american")}
            >
              🍔 Amerika
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("french") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("french")}
            >
              🥖 Fransa
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("mexican") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("mexican")}
            >
              🌮 Meksika
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("mediterranean") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("mediterranean")}
            >
              🫒 Akdeniz
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("middleEastern") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("middleEastern")}
            >
              🧆 Orta Doğu
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("chinese") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("chinese")}
            >
              🥢 Çin
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("japanese") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("japanese")}
            >
              🍱 Japonya
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("indian") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("indian")}
            >
              🍛 Hindistan
            </button>
            
            <button 
              className={`cuisine-btn ${userData.cuisinePreferences.includes("turkish") ? "active" : ""}`} 
              onClick={() => handleCuisineSelection("turkish")}
            >
              🍢 Türkiye
            </button>
          </div>
          
          <button className="continue-btn" onClick={handleCuisineComplete}>
            Devam <span className="arrow">→</span>
          </button>
        </div>
      </div>
    );
  };
  
  // Render the appropriate step based on current step index
  const renderContent = () => {
    switch(currentStep) {
      case 0:
        return renderFirstStep();
      case 1:
        return renderSecondStep();
      case 2:
        return renderThirdStep();
      case 3:
        return <GenderSelection onSelect={handleGenderSelection} />;
      case 4:
        return renderAgeRangeStep();
      case 5:
        return renderCookingLevelStep();
      case 6:
        return renderCuisinePreferencesStep();
      default:
        return renderFirstStep();
    }
  };

  return (
    <div className="onboarding-container">
      {renderContent()}
      <Footer />
    </div>
  );
};

export default Onboarding; 